import CampaignPage from './CampaignPage';

export default CampaignPage;
